export default (params) => ({
  trigger: {
    name: 'insurance_selector.view',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'add_to_cart_overlay',
          'add_to_cart_page',
          'shopping_cart',
          'employee_atc_page',
          'employee_ato_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'view_items',
      params: {
        has_highlighted_segment: null,
      },
    },
    nonInt: true,
  },
});
